export const languageCookie = "__bauhub_lang"
export const currentOrgIdCookie = "__current_organization"
export const userDisplayNameCookie = "__user_displayName"
export const inactivityStartTimeCookie = "bm_inactivity_start_time"

// ----Set by Backend----
const cookieEnv = process.env.REACT_APP_ENV
export const authStatusCookie = `bm_auth_status_${cookieEnv}`
export const authErrorCookie = `bm_auth_error_${cookieEnv}`
export const loginModeCookie = `bm_auth_login_mode_${cookieEnv}`
export const emailVerifiedCookie = `bm_auth_email_verification_status_${cookieEnv}`
export const otpVerificationStatusCookie = `bm_auth_otp_verification_status_${cookieEnv}`
// xx--Set by Backend----xx

// invitation cookie
export const invitationCookie = "bm_invitation_data"
export const invitationTypeCookie = "bm_invitation_type"

// plugin cookies
export const isPluginCookie = "plugin"
export const pluginTypeCookie = "pluginType"
export const pluginIdCookie = "pluginId"
